import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import { useRole } from "../hooks/useRole.js";
import AuthLoadingScreen from "./AuthLoadingScreen.jsx";

export default function RoleRoute({ children, allowedRole = "any" }) {
    const location = useLocation();
    const { status } = useAuth();
    const role = useRole();

    if (role === "loading" || status === "loading") {
        return <AuthLoadingScreen />;
    }

    if (role === "unauthenticated") {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (allowedRole === "coach" && role !== "coach") {
        return <Navigate to="/programs" replace />;
    }

    if (allowedRole === "client" && role !== "client") {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
